import { render, staticRenderFns } from "./Vinoteca.vue?vue&type=template&id=5d090926&scoped=true&"
var script = {}
import style0 from "./Vinoteca.vue?vue&type=style&index=0&id=5d090926&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d090926",
  null
  
)

export default component.exports